import { dangerColor, primaryColor, warningColor } from "../../../assets/components/material-dashboard-pro-react";
export const colorMap = {
  info: primaryColor[0],
  warning: warningColor[0],
  error: dangerColor[0],
}